import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ClimeDocPageUI from './ClimeDocPageUI.js'

class ClimeDocPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      bucketList: null,
    }
  }

  render() {
    return (
      <ClimeDocPageUI
        context={this.props.context}
        bucketList={this.state.bucketList}
        onRefreshClick={this.onRefreshClick}
        onUpdateBucketList={this.onUpdateBucketList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getBuckets(context)
  }

  getBuckets(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/s3contents/buckets`,
      cacheKey: CacheKeys.Buckets(),
      callback: this.getBucketsCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context)
  }

  getBucketsCallback = (response) => {
    this.setState({bucketList : response.bucketList})
  }

  onUpdateBucketList = (bucketList) => {
    this.setState({bucketList: bucketList})
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Buckets())
    this.setState({bucketList: null}, () => {
      this.getBuckets(context)
    })
  }
}

export default withRouter(ClimeDocPageSF)
